const ButtonDropdownControls = (($) => {
    class ButtonDropdown {
        constructor(node) {
            this.node = node;
            this.$node = $(this.node);
            this.$dropdown = this.$node.find('.dropdown');
        }

        init() {
            this.setEventHandlers();
        }

        setEventHandlers() {
            this.$node.on('click', (e) => {
                e.stopPropagation(); // Stop propagation to prevent document click handler from firing
                this.toggleDropdown();
            });

            // Listen for clicks on the document to close this dropdown if the click occurred outside of this dropdown's elements
            $(document).on('click.buttonDropdown', (e) => {
                // Check if the click is outside the dropdown and not on another dropdown button
                if (!this.$node.is(e.target) && this.$node.has(e.target).length === 0) {
                    this.closeDropdown();
                }
            });

            // Special handling when nested within a navigation menu
            $(document).on('click.navMenu', '.navigation-menu', (e) => {
                if (!this.$node.is(e.target) && this.$node.has(e.target).length === 0) {
                    this.closeDropdown();
                }
            });
        }

        toggleDropdown() {
            const isOpen = this.$node.attr('aria-expanded') === 'true';
            this.$node.attr('aria-expanded', !isOpen);
            this.$dropdown.attr('aria-hidden', isOpen);
        }

        closeDropdown() {
            this.$node.attr('aria-expanded', 'false');
            this.$dropdown.attr('aria-hidden', 'true');
        }
    }

    return {
        init({ selector } = {}) {
            $(selector).each((index, parent) => {
                const module = new ButtonDropdown(parent);
                module.init();
            });
        },
    };
})(window.jQuery);

// DOM Ready
(($) => {
    $(document).ready(() => {
        ButtonDropdownControls.init({
            selector: "[data-button-dropdown]",
        });
    });
})(window.jQuery);
